export type PromoEventName =
  | "promo_impression"
  | "promo_cta_click"
  | "promo_dismiss";

type PromoEventParams = Record<string, string | number | boolean>;

type GtagWindow = Window & {
  gtag?: (command: string, eventName: string, params?: PromoEventParams) => void;
};

/**
 * Sends a promo event to Google Analytics when gtag is present.
 * Never throws: analytics failures must not break the page.
 */
export const trackPromoEvent = (
  eventName: PromoEventName,
  params: PromoEventParams = {},
): void => {
  if (typeof window === "undefined") return;

  const gtag = (window as GtagWindow).gtag;
  if (typeof gtag !== "function") return;

  try {
    gtag("event", eventName, { page_section: "promo", ...params });
  } catch {
    // Analytics is non-critical; ignore transport errors.
  }
};
